<template functional>
  <div class="tableWithPerPageSelection">
    <div
      v-if="!props.withoutEntete"
      :class="{ 'border-entete': !$slots['before-bar'] }"
      class="entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <slot name="header"></slot>
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="buttons">
            <slot name="action"></slot>
          </div>
        </div>
      </div>
    </div>
    <div v-if="$slots['before-bar']">
      <slot name="before-bar"></slot>
    </div>
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <slot name="bar-left"></slot>
        </div>
      </div>
      <div class="columns level-right">
        <slot name="bar-right"></slot>
      </div>
    </div>
    <div v-if="$slots['before-content']" class="columns mgt-20px">
      <slot name="before-content"></slot>
    </div>
    <slot name="content"></slot>
    <slot name="after-content"></slot>
    <transition
        name="custom-classes-transition"
        enter-active-class="animate__animated animate__slideInRight"
        leave-active-class="animate__animated animate__slideOutRight"
        :duration="10">
            <slot name="filter"></slot>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'ListeTemplate',
  functional: true,
  props: {
    withoutEntete: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>
